import calls from '@/backend/api-calls'

const state = () => ({
  installations: [],
  installationTypes: [],
  selected: [],
  allSelected: false,
  loading: false,
  typesLoading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.installations.map(d => d.id);
  }
}

// actions
const actions = {
  getInstallations: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.installations.get(parameters)
        .then(resp => {
          commit("setInstallations", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addInstallation: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.installations.post(data)
        .then(resp => {
          commit("insertInstallation", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Installation successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateInstallation: ({commit}, { installationId, data }) => {
    return new Promise((resolve, reject) => {
      calls.installation.put(installationId, data)
        .then(resp => {
          commit("insertUpdatedInstallation", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Installation successfully updated'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteInstallation: ({commit}, installationId) => {
    return new Promise((resolve, reject) => {
      calls.installation.delete(installationId)
        .then(resp => {
          commit("removeInstallation", installationId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Installation successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addImage: ({commit}, { installationId, data }) => {
    return new Promise((resolve, reject) => {
      calls.installation.addImage(installationId, data)
        .then(resp => {
          commit("insertUpdatedInstallation", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  },
  getInstallationTypes: ({commit}, parameters) => {
    commit("setTypesLoading", true);
    return new Promise((resolve, reject) => {
      calls.installationTypes.get(parameters)
        .then(resp => {
          commit("setInstallationTypes", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addInstallationType: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.installationTypes.post(data)
        .then(resp => {
          commit("insertInstallationType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateInstallationType: ({commit}, { installationTypeId, data }) => {
    return new Promise((resolve, reject) => {
      calls.installationType.put(installationTypeId, data)
        .then(resp => {
          commit("insertUpdatedInstallationType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteInstallationType: ({commit}, installationTypeId) => {
    return new Promise((resolve, reject) => {
      calls.installationType.delete(installationTypeId)
        .then(resp => {
          commit("removeInstallationType", installationTypeId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Installation type successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setInstallations (state, data) {
    state.installations = data.results.sort(
      (a,b) => a.installation_type_id - b.installation_type_id
    );
    state.pagination = data.pagination;
  },
  insertInstallation (state, data) {
    state.installations.push(data);
  },
  insertUpdatedInstallation (state, data) {
    state.installations.forEach((installation, i) => {
      if (installation.id == data.id) {
        state.installations.splice(i, 1, data);
      }
    })
  },
  removeInstallation (state, id) {
    state.installations.forEach((installation, i) => {
      if (installation.id == id) {
        state.installations.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  // Installation Types
  setTypesLoading(state, status) {
    state.typesLoading = status;
  },
  setInstallationTypes (state, data) {
    state.installationTypes = data.results;
  },
  insertInstallationType (state, data) {
    state.installationTypes.push(data);
  },
  insertUpdatedInstallationType (state, data) {
    state.installationTypes.forEach((type, i) => {
      if (type.id == data.id) {
        state.installationTypes.splice(i, 1, data);
      }
    })
  },
  removeInstallationType (state, id) {
    state.installationTypes.forEach((type, i) => {
      if (type.id == id) {
        state.installationTypes.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}